import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const template1GlobalConfig: GlobalConfig = {
  typography: [
    {
      name: "Default",
      fontFamily: "Poppins, sans-serif",
      fontSize: "20px",
      fontWeight: "600",
      fontStyle: "normal",
    },
    {
      name: "Heading-1",
      fontFamily: "Roboto",
      fontSize: "70px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-2",
      fontFamily: "Roboto",
      fontSize: "64px",
      fontWeight: "900",
      fontStyle: "normal",
    },
    {
      name: "Heading-3",
      fontFamily: "Roboto",
      fontSize: "54px",
      fontWeight: "900",
      fontStyle: "normal",
    },
    {
      name: "Heading-4",
      fontFamily: "Roboto",
      fontSize: "45px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Heading-5",
      fontFamily: "Roboto",
      fontSize: "40px",
      fontWeight: "900",
      fontStyle: "normal",
    },
    {
      name: "Heading-6",
      fontFamily: "Roboto",
      fontSize: "35px",
      fontWeight: "900",
      fontStyle: "normal",
    },
    {
      name: "Body",
      fontFamily: "Poppins",
      fontSize: "28px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Button",
      fontFamily: "Poppins",
      fontSize: "32px",
      fontWeight: "700",
      fontStyle: "normal",
    },
  ],
  colors: {
    background: "#FFFFFF",
    forground: "#000000",
    primary: "#00573F",
    secondary: "#FFEF5C",
    tertiary: "#393939",
    quaternary: "#F9ED32",
    link: "#1870EB",
    activeLink: "#1D4ED8",
  },
  breakpoints: {
    mobileMax: 640,
    tabletMin: 641,
    tabletMax: 1024,
    desktopMin: 1025,
  },
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "15px 30px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    position: "relative",
    zIndex: 100,
  },
  responsiveStyles: {
    tablet: {
      padding: "15px 20px",
    },
    mobile: {
      padding: "15px 20px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "1274px",
        margin: "0 auto",
      },
      children: [
        {
          id: generateId(),
          type: "logo" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "FORTI",
              styles: {
                fontSize: "32px",
                fontFamily: "Roboto",
                fontWeight: "bold",
                color: "forground",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "GOLD",
              styles: {
                fontSize: "32px",
                fontFamily: "Roboto",
                fontWeight: "normal",
                color: "forground",
                margin: "0",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            alignItems: "center",
            gap: "64px",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                backgroudColor: "#ffffff00",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "28px",
                color: "rgba(0, 0, 0, 0.70)",
              },
              typography: "Default",
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Benefits",
              styles: {
                fontWeight: "600",
                color: "rgba(0, 0, 0, 0.70)",
              },
              typography: "Default",
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontWeight: "600",
                color: "rgba(0, 0, 0, 0.70)",
              },
              typography: "Default",
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundImage:
                  "conic-gradient(from 54deg at 28% 100%, #FBBC04 5.4deg, #FED159 196.2deg, #FED159 360deg)",
                color: "forground",
                padding: "16px 24px",
                borderRadius: "16px",
                fontWeight: "600",
                height: "60px",
                cursor: "pointer",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
              },
              typography: "Default",
              hoverStyles: {
                transform: "translateY(-2px) scale(1.02)",
                boxShadow: "0 8px 25px rgba(251, 188, 4, 0.5)",
                backgroundImage:
                  "conic-gradient(from 54deg at 28% 100%, #E5A604 5.4deg, #F4C145 196.2deg, #F4C145 360deg)",
              },
              responsiveHoverStyles: {
                mobile: {
                  transform: "scale(1.02)",
                  boxShadow: "0 4px 15px rgba(251, 188, 4, 0.4)",
                },
              },
            },
          ],
        },
        //Hamburger Button
        {
          id: generateId(),
          type: "button" as ElementType,
          content: "☰",
          interactionType: "popup",
          triggerPopup: "mobile-navigation",
          styles: {
            display: "none", // Hidden on desktop
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            backgroundColor: "#F3F3F3",
            border: "none",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            cursor: "pointer",
            marginLeft: "12px",
            fontSize: "18px",
            color: "#333",
            boxShadow: "0px 2px 8px #0000000a",
          },
          responsiveStyles: {
            tablet: {
              display: "flex",
            },
            mobile: {
              display: "flex",
            },
          },
        },
      ],
    },
  ],
});

const createFirstSectionContainer = (globalConfig: GlobalConfig) => {
  const titlePart = {
    id: generateId(),
    type: "container" as ElementType,
    styles: {
      backgroundColor: "#ffffff00",
      display: "flex",
      width: "100%",
      maxWidth: "830px",
      flexDirection: "column",
      padding: "0 30px 0 0",
    },
    responsiveStyles: {
      tablet: {
        order: 1,
      },
      mobile: {
        order: 1,
        padding: "0 0 0 0",
      },
    },
    children: [
      {
        id: generateId(),
        type: "container" as ElementType,
        styles: {
          backgroundColor: "#ffffff00",
          display: "flex",
          flexDirection: "column",
          margin: "0 0 32px 0",
        },
        responsiveStyles: {
          tablet: {
            margin: "0",
          },
          mobile: {
            margin: "0",
          },
        },
        children: [
          {
            id: generateId(),
            type: "heading" as ElementType,
            content: "Restore Your Health From the Inside Out –",
            styles: {
              fontFamily: "Roboto, sans-serif",
              fontSize: "70px",
              fontWeight: "700",
              fontStyle: "normal",
              color: "background",
              margin: "0",
            },
            typography: "Heading-1",
            responsiveStyles: {
              tablet: {
                fontSize: "30px",
                lineHeight: "55px",
              },
              mobile: {
                fontSize: "38px",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
              },
            },
          },
          {
            id: generateId(),
            type: "heading" as ElementType,
            content: "Naturally & Effortlessly!",
            styles: {
              fontSize: "70px",
              fontFamily: "Roboto, sans-serif",
              fontWeight: "700",
              fontStyle: "italic",
              color: "#FBBC04",
              margin: "0",
            },
            typography: "Heading-1",
            responsiveStyles: {
              tablet: {
                fontSize: "38px",
                lineHeight: "55px",
              },
              mobile: {
                fontSize: "38px",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
              },
            },
          },
        ],
      },
      {
        id: generateId(),
        type: "paragraph" as ElementType,
        content:
          "Experts Reveal a Breakthrough Formula That Supports Digestion, Energy & Immunity - No Dieting, No Guesswork!",
        styles: {
          fontSize: "28px",
          fontFamily: "Roboto, sans-serif",
          color: "background",
          fontWeight: "500",
        },
        responsiveStyles: {
          tablet: {
            fontSize: "22px",
            fontWeight: "400",
          },
          mobile: {
            fontSize: "22px",
            fontWeight: "400",
            marginTop: "10px",
            letterSpacing: "-0.22px",
          },
        },
      },
      {
        id: generateId(),
        type: "container" as ElementType,
        styles: {
          backgroundColor: "#ffffff00",
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          margin: "29px 0 0 0",
        },
        responsiveStyles: {
          tablet: {
            gap: "12px",
          },
          mobile: {
            gap: "6px",
          },
        },
        children: [
          {
            id: generateId(),
            type: "image" as ElementType,
            src: "/fortigold/cert-1.png",
            alt: "certificate-1",
            styles: {
              width: "120px",
              height: "120px",
              objectFit: "cover",
              margin: "0",
              padding: "0",
            },
            responsiveStyles: {
              tablet: {
                width: "70px",
                height: "70px",
              },
              mobile: {
                width: "70px",
                height: "66px",
              },
            },
          },
          {
            id: generateId(),
            type: "image" as ElementType,
            src: "/fortigold/cert-2.png",
            alt: "certificate-1",
            styles: {
              width: "120px",
              height: "120px",
              objectFit: "cover",
              margin: "0",
              padding: "0",
            },
            responsiveStyles: {
              tablet: {
                width: "70px",
                height: "70px",
              },
              mobile: {
                width: "70px",
                height: "66px",
              },
            },
          },
          {
            id: generateId(),
            type: "image" as ElementType,
            src: "/fortigold/cert-3.png",
            alt: "certificate-1",
            styles: {
              width: "120px",
              height: "120px",
              objectFit: "cover",
              margin: "0",
              padding: "0",
            },
            responsiveStyles: {
              tablet: {
                width: "70px",
                height: "70px",
              },
              mobile: {
                width: "70px",
                height: "66px",
              },
            },
          },
          {
            id: generateId(),
            type: "image" as ElementType,
            src: "/fortigold/cert-4.png",
            alt: "certificate-1",
            styles: {
              width: "120px",
              height: "120px",
              objectFit: "cover",
              margin: "0",
              padding: "0",
            },
            responsiveStyles: {
              tablet: {
                width: "70px",
                height: "70px",
              },
              mobile: {
                width: "70px",
                height: "66px",
              },
            },
          },
          {
            id: generateId(),
            type: "image" as ElementType,
            src: "/fortigold/cert-5.png",
            alt: "certificate-1",
            styles: {
              width: "120px",
              height: "120px",
              objectFit: "cover",
              margin: "0",
              padding: "0",
            },
            responsiveStyles: {
              tablet: {
                width: "70px",
                height: "70px",
              },
              mobile: {
                width: "70px",
                height: "66px",
              },
            },
          },
        ],
      },
    ],
  };

  return {
    id: generateId(),
    type: "container" as ElementType,
    styles: {
      backgroundColor: "primary",
      padding: "15px 30px",
      display: "flex",
      flexDirection: "column",
      gap: "80px",
      alignItems: "center",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      overflowX: "hidden",
      overflowY: "hidden",
    },
    responsiveStyles: {
      tablet: {
        padding: "15px 20px",
        gap: "60px",
      },
      mobile: {
        padding: "15px 11px",
        gap: "45px",
      },
    },
    children: [
      {
        id: generateId(),
        type: "container" as ElementType,
        styles: {
          backgroundColor: "#ffffff00",
          display: "flex",
          alignItems: "center",
        },
        responsiveStyles: {
          tablet: {
            flexDirection: "column",
          },
          mobile: {
            flexDirection: "column",
          },
        },
        children: [
          titlePart,
          {
            id: generateId(),
            type: "container" as ElementType,
            styles: {
              backgroundColor: "#ffffff00",
              display: "flex",
              position: "relative",
            },
            responsiveStyles: {
              tablet: {
                order: 0,
              },
              mobile: {
                order: 0,
              },
            },
            children: [
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  position: "relative",
                  display: "flex",
                },
                children: [
                  // Gold radial background (decorative)
                  {
                    id: generateId(),
                    type: "container" as ElementType,
                    styles: {
                      position: "absolute",
                      top: "-300px",
                      left: "-500px",
                      width: "1328px",
                      height: "1328px",
                      borderRadius: "1328px",
                      backgroundImage:
                        "radial-gradient(50% 50% at 50% 50%, #fed159bd 0%, #fed1595c 50.53%, #fed15900 100%)",
                      zIndex: 10,
                    },
                    responsiveStyles: {
                      tablet: {
                        top: "-150px",
                        left: "-150px",
                        width: "600px",
                        height: "600px",
                      },
                      mobile: {
                        top: "-127px",
                        left: "-127px",
                        width: "508px",
                        height: "508px",
                      },
                    },
                  },
                  // Product image
                  {
                    id: generateId(),
                    type: "image" as ElementType,
                    src: "/fortigold/fortigold-bottle-1.png",
                    alt: "Restaurant hero image",
                    styles: {
                      maxWidth: "400px",
                      objectFit: "contain",
                      margin: "0",
                      padding: "0",
                      position: "relative",
                      zIndex: 20,
                    },
                    responsiveStyles: {
                      tablet: {
                        maxWidth: "300px",
                      },
                      mobile: {
                        maxWidth: "254px",
                      },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: generateId(),
        type: "carousel" as ElementType,
        autoPlay: { desktop: true },
        loop: { desktop: true },
        pagination: { desktop: true },
        slidesPerView: { desktop: 2, tablet: 1, mobile: 1 },
        spaceBetween: { desktop: 30, tablet: 16, mobile: 8 },
        autoplayDelay: { desktop: 2500, mobile: 2000 },
        styles: {
          gap: "80px",
          width: "100%",
          maxWidth: "1274px",
          margin: "0 auto",
          padding: "40px 0 40px 0",
          zIndex: 20,
        },
        responsiveStyles: {
          tablet: {
            flexDirection: "column",
            alignItems: "center",
            gap: "40px",
            padding: "20px 0 20px 0",
          },
          mobile: {
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "0",
          },
        },
        children: [
          // Testimonial 1 - Horizontal layout matching original
          {
            id: generateId(),
            type: "container" as ElementType,
            styles: {
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              gap: "24px",
              marginBottom: "16px",
              width: "100%",
              height: "200px",
              borderRadius: "24px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            },
            responsiveStyles: {
              tablet: {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                padding: "20px",
                height: "180px",
              },
              mobile: {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "12px",
                padding: "16px",
                height: "160px",
              },
            },
            children: [
              {
                id: generateId(),
                type: "image" as ElementType,
                src: "/fortigold/usr-1.png",
                alt: "David M.",
                styles: {
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  flexShrink: "0",
                },
                responsiveStyles: {
                  tablet: {
                    width: "80px",
                    height: "80px",
                  },
                  mobile: {
                    width: "60px",
                    height: "60px",
                  },
                },
              },
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "16px",
                  flex: "1",
                },
                children: [
                  {
                    id: generateId(),
                    type: "container" as ElementType,
                    styles: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "6px",
                    },
                    children: [
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "heading" as ElementType,
                        content: "5/5",
                        styles: {
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "25px",
                          lineHeight: "normal",
                          marginLeft: "12px",
                          margin: "0",
                        },
                      },
                    ],
                  },
                  {
                    id: generateId(),
                    type: "container" as ElementType,
                    styles: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      gap: "4px",
                    },
                    children: [
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/fortigold/testimonials-quote.png",
                        alt: "Testimonials Quote Image",
                        styles: {
                          width: "30px",
                          height: "30px",
                          objectFit: "contain",
                          marginTop: "-10px",
                          flexShrink: "0",
                        },
                      },
                      {
                        id: generateId(),
                        type: "paragraph" as ElementType,
                        content:
                          "My digestion and energy have improved so much — I didn't expect results this fast!",
                        styles: {
                          color: "#ffffff",
                          fontSize: "22px",
                          fontWeight: "400",
                          lineHeight: "25px",
                          fontFamily: "Poppins",
                          margin: "0",
                        },
                        responsiveStyles: {
                          tablet: {
                            fontSize: "18px",
                            lineHeight: "22px",
                          },
                          mobile: {
                            fontSize: "16px",
                            lineHeight: "20px",
                          },
                        },
                      },
                    ],
                  },
                  {
                    id: generateId(),
                    type: "paragraph" as ElementType,
                    content: "<b>David M.</b> - Verified FORTIGOLD™ User",
                    styles: {
                      color: "#ffffff",
                      fontWeight: "400",
                      fontSize: "18px",
                      lineHeight: "31px",
                      display: "inline-block",
                      margin: "0",
                    },
                    responsiveStyles: {
                      tablet: {
                        fontSize: "16px",
                        lineHeight: "24px",
                      },
                      mobile: {
                        fontSize: "14px",
                        lineHeight: "20px",
                      },
                    },
                  },
                ],
              },
            ],
          },
          // Testimonial 2 - Horizontal layout matching original
          {
            id: generateId(),
            type: "container" as ElementType,
            styles: {
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              gap: "24px",
              marginBottom: "16px",
              width: "100%",
              height: "200px",
              borderRadius: "24px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            },
            responsiveStyles: {
              tablet: {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                padding: "20px",
                height: "180px",
              },
              mobile: {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "12px",
                padding: "16px",
                height: "160px",
              },
            },
            children: [
              {
                id: generateId(),
                type: "image" as ElementType,
                src: "/fortigold/usr_testimonials.png",
                alt: "Sarah K.",
                styles: {
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  flexShrink: "0",
                },
                responsiveStyles: {
                  tablet: {
                    width: "80px",
                    height: "80px",
                  },
                  mobile: {
                    width: "60px",
                    height: "60px",
                  },
                },
              },
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "16px",
                  flex: "1",
                },
                children: [
                  {
                    id: generateId(),
                    type: "container" as ElementType,
                    styles: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "6px",
                    },
                    children: [
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/images/movyo/star.svg",
                        alt: "star",
                        styles: {
                          width: "35px",
                          height: "35px",
                        },
                      },
                      {
                        id: generateId(),
                        type: "heading" as ElementType,
                        content: "5/5",
                        styles: {
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "25px",
                          lineHeight: "normal",
                          marginLeft: "12px",
                          margin: "0",
                        },
                      },
                    ],
                  },
                  {
                    id: generateId(),
                    type: "container" as ElementType,
                    styles: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      gap: "4px",
                    },
                    children: [
                      {
                        id: generateId(),
                        type: "image" as ElementType,
                        src: "/fortigold/testimonials-quote.png",
                        alt: "Testimonials Quote Image",
                        styles: {
                          width: "30px",
                          height: "30px",
                          objectFit: "contain",
                          marginTop: "-10px",
                          flexShrink: "0",
                        },
                      },
                      {
                        id: generateId(),
                        type: "paragraph" as ElementType,
                        content:
                          "I've been taking FortiGold for 2 months and the joint pain relief is incredible — I can finally enjoy my daily walks again!",
                        styles: {
                          color: "#ffffff",
                          fontSize: "22px",
                          fontWeight: "400",
                          lineHeight: "25px",
                          fontFamily: "Poppins",
                          margin: "0",
                        },
                        responsiveStyles: {
                          tablet: {
                            fontSize: "18px",
                            lineHeight: "22px",
                          },
                          mobile: {
                            fontSize: "16px",
                            lineHeight: "20px",
                          },
                        },
                      },
                    ],
                  },
                  {
                    id: generateId(),
                    type: "paragraph" as ElementType,
                    content: "<b>Sarah K.</b> - Verified FORTIGOLD™ User",
                    styles: {
                      color: "#ffffff",
                      fontWeight: "400",
                      fontSize: "18px",
                      lineHeight: "31px",
                      display: "inline-block",
                      margin: "0",
                    },
                    responsiveStyles: {
                      tablet: {
                        fontSize: "16px",
                        lineHeight: "24px",
                      },
                      mobile: {
                        fontSize: "14px",
                        lineHeight: "20px",
                      },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
};

const createFortigoldFeatureSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    position: "relative",
    width: "100%",
    minHeight: "543px",
    backgroundImage: "url('/fortigold/fortigold-bg.png')", // Update path as needed
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    zIndex: 1,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        position: "relative",
        zIndex: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "rgba(0,0,0,0.6)",
            padding: "30px 50px 40px",
            width: "100%",
            maxWidth: "1200px",
            border: "4px solid #7A7A7A",
            boxShadow: "0 16px 24px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "35px 0",
          },
          responsiveStyles: {
            tablet: {
              maxWidth: "95%",
            },
            mobile: {
              maxWidth: "95%",
              padding: "23px 30px",
              margin: "42px 15px",
              alignItems: "flex-start",
            },
          },
          children: [
            // Title
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "<b>FORTI</b>GOLD",
              styles: {
                textAlign: "center",
                fontWeight: 700,
                fontFamily: "Poppins, sans-serif",
                fontSize: "3.5rem",
                textTransform: "uppercase",
                backgroundImage: "linear-gradient(to bottom, #FFD56F, #D6AC4F)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "1px",
                margin: 0,
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "46.2816px",
                },
              },
            },
            // Features Grid
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "grid",
                gridTemplateColumns: "repeat(3, auto)",
                gridTemplateRows: "repeat(2, auto)",
                rowGap: "45px",
                columnGap: "76px",
                width: "100%",
                justifyContent: "space-between",
              },
              responsiveStyles: {
                tablet: {
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "30px",
                },
                mobile: {
                  gridTemplateColumns: "1fr",
                  gap: "25px",
                },
              },
              children: [
                // Feature Items
                ...[
                  "Natural Formula",
                  "Easy To Use",
                  "Non-GMO",
                  "No Stimulants",
                  "Non-Habit Forming",
                  "Gluten Free",
                ].map((text) => ({
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/fortigold/check-box.png",
                      alt: "feature-icon",
                      styles: {
                        width: "39px",
                        height: "39px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        mobile: {
                          width: "33px",
                          height: "33px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: text,
                      styles: {
                        fontFamily: "Poppins, sans-serif",
                        color: "secondary",
                        fontSize: "33px",
                        lineHeight: "31px",
                        fontWeight: 600,
                        margin: 0,
                        whiteSpace: "nowrap",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "25px",
                        },
                      },
                    },
                  ],
                })),
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createHealthSolutionSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "background",
    padding: "90px 0 0 0",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "40px 0 20px 0" },
    mobile: { padding: "40px 0 20px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "stretch",
        gap: "40px",
        maxWidth: "1304px",
        margin: "0 auto",
        width: "100%",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "column",
          textAlign: "left",
          padding: "0 20px",
          alignItems: "center",
        },
        mobile: {
          flexDirection: "column",
          textAlign: "left",
          padding: "0 20px",
          alignItems: "center",
        },
      },
      children: [
        // Image (hidden on tablet/mobile)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "0 0 474px",
            display: "block",
          },
          responsiveStyles: {
            tablet: { display: "none" },
            mobile: { display: "none" },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/fortigold/lady-photo.png",
              alt: "Woman enjoying health benefits of FortiGold supplement",
              styles: {
                width: "100%",
                height: "auto",
                display: "block",
              },
            },
          ],
        },
        // Content
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          },
          children: [
            // Mobile image (hidden on desktop)
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { display: "none" },
              responsiveStyles: {
                tablet: {
                  display: "block",
                  marginBottom: "32px",
                  width: "100%",
                  height: "529px",
                },
                mobile: {
                  display: "block",
                  marginBottom: "32px",
                  width: "100%",
                  height: "329px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/lady-photo.png",
                  alt: "Woman enjoying health benefits of FortiGold supplement",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "70% 10%",
                  },
                  responsiveStyles: {
                    mobile: { width: "100%" },
                  },
                },
              ],
            },
            // Heading
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                'The Simple Missing Piece to a Healthier, More Energized <span style="background:linear-gradient(to bottom,#de9c00,#f7c600);-webkit-background-clip:text;background-clip:text;color:transparent;text-decoration-line:underline;text-decoration-color:#f7c600;text-decoration-thickness:3px;text-underline-offset:6px;">You</span>',
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "61px",
                lineHeight: "80px",
                marginBottom: "40px",
                letterSpacing: "-1.83px",
                color: "forground",
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "38px",
                  order: -1, // This will move it to the top only in mobile view
                  lineHeight: "55px",
                  letterSpacing: "-1.14px",
                  marginBottom: "32px",
                },
              },
            },
            // Paragraphs
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "If you've been struggling with low energy, stubborn weight, bloating, or brain fog, you're not alone. For years, people have searched for solutions—only to be met with confusing diets, expensive supplements, and temporary fixes.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                lineHeight: "40px",
                letterSpacing: "-0.28px",
                marginBottom: "20px",
                color: "forground",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "32px",
                  letterSpacing: "-0.22px",
                },
                tablet: { fontSize: "21.5px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "But what if the real answer was something your body was designed to absorb naturally?",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                lineHeight: "40px",
                letterSpacing: "-0.28px",
                marginBottom: "20px",
                color: "forground",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "32px",
                  letterSpacing: "-0.22px",
                },
                tablet: { fontSize: "21.5px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Introducing FORTIGOLD – a breakthrough formula that supports gut health, strengthens immunity, and boosts metabolism naturally. This powerful, nature-derived solution helps you feel like YOU again - without restrictive diets or complicated routines.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                lineHeight: "40px",
                letterSpacing: "-0.28px",
                marginBottom: "40px",
                color: "forground",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "32px",
                  letterSpacing: "-0.22px",
                  marginBottom: "0",
                },
                tablet: { fontSize: "21.5px" },
              },
            },
            // CTA Wrapper
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                marginTop: "37px",
                marginBottom: "37px",
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
              },
              responsiveStyles: {
                tablet: { marginTop: "37px" },
                mobile: { marginTop: "25px", marginBottom: "25px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "button" as ElementType,
                  content: "ORDER NOW",
                  styles: {
                    display: "inline-block",
                    padding: "10px",
                    backgroundImage:
                      "conic-gradient(from 48deg at 43.42% 100%, #F49D00 5.4deg, #FAC600 196.2deg, #FCC709 360deg)",
                    border: "3px solid rgba(255, 237, 166, 0.8)",
                    borderRadius: "14px",
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: 900,
                    color: "forground",
                    textDecoration: "none",
                    height: "100px",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    maxWidth: "336px",
                    width: "100%",
                    fontSize: "38px",
                  },
                  responsiveStyles: {
                    mobile: {
                      maxWidth: "217px",
                      fontSize: "28px",
                      lineHeight: "42px",
                      letterSpacing: "-0.82px",
                      height: "64.5px",
                    },
                  },
                },
              ],
            },
            // Transformation Text
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                'Your Health Transformation <span style="color:#1f9853;font-weight:700;">Starts Now!</span>',
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 700,
                fontSize: "28px",
                lineHeight: "40px",
                letterSpacing: "-0.28px",
                margin: 0,
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "32px",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldWorksSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    padding: "90px 0",
    backgroundColor: "background",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { display: "none" },
    mobile: { display: "none" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1276px",
        margin: "0 auto",
        padding: "0 20px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      },
      children: [
        // Header
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            maxWidth: "1148px",
            margin: "0 auto 110px",
            width: "100%",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Why FORTIGOLD Works When Nothing Else Does",
              styles: {
                maxWidth: "1032px",
                margin: "0 auto 24px",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "64px",
                lineHeight: "72px",
                letterSpacing: "-1.92px",
                color: "forground",
                opacity: "0.9",
                textAlign: "center",
              },
              typography: "Heading-2",
              responsiveStyles: {
                tablet: { fontSize: "42px", lineHeight: "48px" },
                mobile: { fontSize: "32px", lineHeight: "38px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Most supplements treat symptoms, but FORTIGOLD helps fix the root cause. Using bioactive colostrum, this revolutionary formula helps repair your gut, strengthens immunity, and supports the restoration of full-body vitality in just days.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "28px",
                lineHeight: "40px",
                letterSpacing: "-0.28px",
                color: "rgba(57,57,57,1)",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { fontSize: "20px", lineHeight: "30px" },
                mobile: { fontSize: "18px", lineHeight: "28px" },
              },
            },
          ],
        },
        // Benefits
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            maxWidth: "1276px",
            margin: "0 auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "76px",
          },
          children: [
            // Row 1
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                gap: "101px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                  gap: "40px",
                  alignItems: "center",
                },
                mobile: {
                  flexDirection: "column",
                  gap: "40px",
                  alignItems: "center",
                },
              },
              children: [
                // Benefit 1
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    maxWidth: "574px",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                    mobile: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "197px",
                        height: "197px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        mobile: { width: "150px", height: "150px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigoldWorksSection1.png",
                          alt: "Gut health diagram",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {},
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "Helps Maintain a Healthy Gut Barrier",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 700,
                            fontSize: "36px",
                            lineHeight: "40px",
                            letterSpacing: "-0.72px",
                            color: "forground",
                            opacity: "0.9",
                            marginBottom: "12px",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "28px", lineHeight: "34px" },
                            mobile: { fontSize: "24px", lineHeight: "30px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Helps digestion, elimination of bloating, and helps reduces food sensitivities.",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "24px",
                            lineHeight: "35px",
                            letterSpacing: "-0.24px",
                            color: "rgba(57,57,57,1)",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "18px", lineHeight: "28px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Benefit 2
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    maxWidth: "574px",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                    mobile: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "197px",
                        height: "197px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        mobile: { width: "150px", height: "150px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigoldWorksSection2.png",
                          alt: "Person with energy",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {},
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "Boosts Natural Energy & Focus",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 700,
                            fontSize: "36px",
                            lineHeight: "40px",
                            letterSpacing: "-0.72px",
                            color: "forground",
                            opacity: "0.9",
                            marginBottom: "12px",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "28px", lineHeight: "34px" },
                            mobile: { fontSize: "24px", lineHeight: "30px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Wake up refreshed, stay sharp all day—without caffeine crashes.",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "24px",
                            lineHeight: "35px",
                            letterSpacing: "-0.24px",
                            color: "rgba(57,57,57,1)",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "18px", lineHeight: "28px" },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Row 2
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                gap: "101px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                  gap: "40px",
                  alignItems: "center",
                },
                mobile: {
                  flexDirection: "column",
                  gap: "40px",
                  alignItems: "center",
                },
              },
              children: [
                // Benefit 3
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    maxWidth: "574px",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                    mobile: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "197px",
                        height: "197px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        mobile: { width: "150px", height: "150px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigoldWorksSection3.png",
                          alt: "Weight management",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {},
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "Supports Healthy Weight & Metabolism",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 700,
                            fontSize: "36px",
                            lineHeight: "40px",
                            letterSpacing: "-0.72px",
                            color: "forground",
                            opacity: "0.9",
                            marginBottom: "12px",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "28px", lineHeight: "34px" },
                            mobile: { fontSize: "24px", lineHeight: "30px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Helps balances gut bacteria to burn fat naturally & reduce cravings.",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "24px",
                            lineHeight: "35px",
                            letterSpacing: "-0.24px",
                            color: "rgba(57,57,57,1)",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "18px", lineHeight: "28px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Benefit 4
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    maxWidth: "574px",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                    mobile: {
                      flexDirection: "column",
                      textAlign: "center",
                      maxWidth: "100%",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "197px",
                        height: "197px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        mobile: { width: "150px", height: "150px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigoldWorksSection4.png",
                          alt: "Immune system",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {},
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "Strengthens Immunity",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 700,
                            fontSize: "36px",
                            lineHeight: "40px",
                            letterSpacing: "-0.72px",
                            color: "forground",
                            opacity: "0.9",
                            marginBottom: "12px",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "28px", lineHeight: "34px" },
                            mobile: { fontSize: "24px", lineHeight: "30px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Defends against illness, inflammation, and low-grade infections.",
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "24px",
                            lineHeight: "35px",
                            letterSpacing: "-0.24px",
                            color: "rgba(57,57,57,1)",
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "18px", lineHeight: "28px" },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldGutHealthSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundImage: "linear-gradient(to right, #00573F, #005840)",
    padding: "129px 0",
    color: "background",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  responsiveStyles: {
    tablet: { padding: "85px 0" },
    mobile: { padding: "70px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0px",
        maxWidth: "1500px",
        margin: "0 auto",
        padding: "0 50px 0 100px",
        width: "100%",
        position: "relative",
      },
      responsiveStyles: {
        tablet: { flexDirection: "column", gap: "50px" },
        mobile: { flexDirection: "column", gap: "30px" },
      },
      children: [
        // Product Image (desktop)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            position: "relative",
            flex: "0 0 600px",
            display: "block",
            minWidth: "340px",
            minHeight: "420px",
          },
          responsiveStyles: {
            tablet: { display: "none" },
            mobile: { display: "none" },
          },
          children: [
            // Gold radial background (decorative)
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                position: "absolute",
                top: "-375px",
                left: "-375px",
                width: "1416px",
                height: "1416px",
                borderRadius: "1416px",
                backgroundImage:
                  "radial-gradient(50% 50% at 50% 50%, #fed159bd 0%, #fed1595c 50.53%, #fed15900 100%)",
                zIndex: 0,
              },
              responsiveStyles: {
                tablet: {
                  top: "-50px",
                  left: "-90px",
                  width: "1200px",
                  height: "1200px",
                },
                mobile: {
                  top: "-160px",
                  left: "-175px",
                  width: "704px",
                  height: "704px",
                },
              },
            },
            // Product image
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/fortigold/fortigold-bottle-1.png",
              alt: "FORTIGOLD - The #1 GUT HEALER",
              styles: {
                maxWidth: "100%",
                height: "648px",
                width: "484px",
                zIndex: 1,
                position: "relative",
                display: "block",
              },
            },
            // Satisfaction Badge
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/fortigold/satisfaction-badge.png",
              alt: "100% Satisfaction Guarantee",
              styles: {
                position: "absolute",
                width: "227px",
                height: "229px",
                left: "-80px",
                top: "-40px",
                zIndex: 2,
              },
              responsiveStyles: {
                tablet: {
                  width: "140px",
                  height: "140px",
                  right: "-20px",
                  top: "30px",
                },
                mobile: {
                  width: "100px",
                  height: "100px",
                  right: "-10px",
                  top: "20px",
                },
              },
            },
          ],
        },
        // Content
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: 1,
            maxWidth: "765px",
            zIndex: 1,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          },
          children: [
            // Headline
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                'The Fastest, Most Effective Way to Restore Your Health <span style="display:block;color:#fcd159;">Naturally</span>',
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "64px",
                lineHeight: "80px",
                marginBottom: "32px",
                letterSpacing: "-1.92px",
                zIndex: 1,
                position: "relative",
                color: "background",
                opacity: "0.9",
              },
              typography: "Heading-2",
              responsiveStyles: {
                tablet: { fontSize: "44px" },
                mobile: {
                  fontSize: "40px",
                  lineHeight: "55px",
                  letterSpacing: "-1.2px",
                },
              },
            },
            // Product image (mobile/tablet only)
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "none",
                maxWidth: "100%",
                marginBottom: "8px",
              },
              responsiveStyles: {
                tablet: {
                  display: "block",
                  maxWidth: "500px",
                  margin: "0 auto 38px",
                },
                mobile: {
                  display: "block",
                  maxWidth: "100%",
                  margin: "0",
                },
              },
              children: [
                // Gold radial background (decorative)
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    position: "absolute",
                    top: "20px",
                    left: "-160px",
                    width: "704px",
                    height: "704px",
                    borderRadius: "704px",
                    backgroundImage:
                      "radial-gradient(50% 50% at 50% 50%, #fed159bd 0%, #fed1595c 50.53%, #fed15900 100%)",
                    zIndex: 0,
                  },
                  responsiveStyles: {
                    tablet: {
                      top: "-50px",
                      left: "-90px",
                      width: "1200px",
                      height: "1200px",
                    },
                    mobile: {
                      top: "150px",
                      left: "unset",
                      right: "-150px",
                      width: "704px",
                      height: "704px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/fortigold-bottle-quality-1.png",
                  alt: "FORTIGOLD - The #1 GUT HEALER",
                  styles: {
                    width: "100%",
                    zIndex: 1,
                    position: "relative",
                  },
                },
              ],
            },
            // Feature box 1
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { marginBottom: "32px", zIndex: 1, position: "relative" },
              responsiveStyles: {
                tablet: { marginBottom: "16px" },
                mobile: { marginBottom: "25px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Clinically Proven Gut Repair",
                  styles: {
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 900,
                    fontSize: "28px",
                    lineHeight: "40px",
                    letterSpacing: "-0.28px",
                    marginBottom: "16px",
                    color: "background",
                    opacity: "0.9",
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: "25px",
                      color: "background",
                      opacity: "0.9",
                      lineHeight: "35px",
                      letterSpacing: "-0.25px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "FORTIGOLD helps support and strengthen your gut lining for better digestion and vitality.",
                  styles: {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 400,
                    fontSize: "28px",
                    letterSpacing: "-0.28px",
                    lineHeight: "40px",
                    marginBottom: "8px",
                  },
                  typography: "Body",
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: {
                      fontSize: "22px",
                      lineHeight: "40px",
                      letterSpacing: "-0.22px",
                      fontFamily: "Poppins, sans-serif",
                      marginBottom: "0",
                    },
                  },
                },
              ],
            },
            // Feature box 2
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { marginBottom: "32px", zIndex: 1, position: "relative" },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Boosts Energy & Mental Clarity",
                  styles: {
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 900,
                    fontSize: "28px",
                    lineHeight: "40px",
                    letterSpacing: "-0.28px",
                    marginBottom: "16px",
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: "25px",
                      color: "background",
                      opacity: "0.9",
                      lineHeight: "35px",
                      letterSpacing: "-0.25px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Wake up refreshed and stay focused all day without caffeine crashes or brain fog.",
                  styles: {
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "28px",
                    lineHeight: "40px",
                    letterSpacing: "-0.28px",
                    marginBottom: "8px",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: {
                      fontSize: "22px",
                      lineHeight: "40px",
                      letterSpacing: "-0.22px",
                      fontFamily: "Poppins, sans-serif",
                      marginBottom: "0",
                    },
                  },
                },
              ],
            },
            // Buy Now Button
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "BUY NOW",
              styles: {
                display: "inline-block",
                backgroundImage:
                  "conic-gradient(from 48deg at 45.42% 100%, #F49D00 5.4deg, #FAC600 196.20001deg, #FCC709 360deg)",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "48px",
                lineHeight: "normal",
                color: "forground",
                padding: "10px",
                height: "100px",
                borderRadius: "15px",
                textAlign: "center",
                textDecoration: "none",
                border: "3px solid rgba(255, 235, 59, 0.3)",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                transition: "all 0.3s ease",
                maxWidth: "336px",
                width: "100%",
                cursor: "pointer",
              },
              responsiveStyles: {
                tablet: { fontSize: "36px", padding: "8px 24px" },
                mobile: {
                  fontSize: "28px",
                  maxWidth: "217px",
                  lineHeight: "42px",
                  letterSpacing: "-0.82px",
                  height: "64.5px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldTestimonialsSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "background",
    color: "forground",
    padding: "104px 0",
    width: "100%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    mobile: { padding: "40px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 15px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      responsiveStyles: {
        tablet: { padding: "0" },
        mobile: { padding: "0" },
      },
      children: [
        // Customer Say + Stars + Review Count
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            marginBottom: "104px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "50px",
          },
          responsiveStyles: {
            tablet: { marginBottom: "60px", gap: "25px", padding: "0 20px" },
            mobile: { marginBottom: "39px", gap: "18px", padding: "0 20px" },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "Our Customer say",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "28px",
                color: "forground",
                opacity: "0.6",
                margin: 0,
              },
              typography: "Body",
              responsiveStyles: {
                mobile: {
                  fontSize: "18px",
                  lineHeight: "28px",
                  letterSpacing: "-0.18px",
                },
              },
            },
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/fortigold/5-star-rating.png", // Use 5 stars in a row
              alt: "5-star reviews",
              styles: {
                width: "714px",
                maxWidth: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                margin: 0,
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                '<span style="color:${"forground"};font-weight:900;">Countless Five-Star Reviews</span> and Growing',
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "40px",
                letterSpacing: "-0.4px",
                color: "forground",
                opacity: "0.6",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "28px" },
                mobile: {
                  fontSize: "22px",
                  lineHeight: "28px",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
        // Header
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            marginBottom: "60px",
          },
          responsiveStyles: {
            tablet: { marginBottom: "30px", padding: "0 20px" },
            mobile: { marginBottom: "39px", padding: "0 20px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "What Real People Are Saying <br/>About FORTIGOLD",
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "64px",
                lineHeight: "72px",
                marginBottom: "24px",
                letterSpacing: "-1.92px",
                color: "forground",
                opacity: "0.9",
              },
              typography: "Heading-2",
              responsiveStyles: {
                tablet: { fontSize: "40px" },
                mobile: {
                  fontSize: "38px",
                  lineHeight: "48px",
                  letterSpacing: "-1.14px",
                  marginBottom: "16px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Many people have already experienced the life-changing benefits of FORTIGOLD.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontWeight: 500,
                letterSpacing: "-0.28px",
                color: "forground",
                margin: 0,
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "28px ",
                  letterSpacing: "-0.22px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "Here's what they have to say:",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontWeight: 500,
                letterSpacing: "-0.28px",
                color: "forground",
                margin: 0,
                marginTop: "12px",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "28px ",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
        // Gallery (single image for now)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            marginBottom: "73px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          },
          responsiveStyles: {
            tablet: { marginBottom: "30px", padding: "0 20px" },
            mobile: { marginBottom: "35px", padding: "0 20px" },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/fortigold/testimonials1.png", // Placeholder for group image
              alt: "Man holding Fortigold product",
              styles: {
                width: "100%",
                maxWidth: "1300px",
                borderRadius: "8px",
                objectFit: "cover",
              },
              responsiveStyles: {
                mobile: {
                  width: "100%",
                  height: "301px",
                },
              },
            },
          ],
        },
        // Reviews
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            maxWidth: "1267px",
            margin: "0 auto",
            width: "100%",
          },
          responsiveStyles: {
            mobile: {
              maxWidth: "100%",
              gap: "25px",
            },
          },
          children: [
            // Review 1
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                background: "#fff",
                borderRadius: "24px",
                padding: "32px 24px",
                border: "4px solid rgba(0, 0, 0, 0.05)",
                color: "forground",
                display: "flex",
                gap: "30px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                tablet: {
                  gap: "18px",
                  padding: "15px",
                  borderRadius: "0px",
                },
                mobile: {
                  gap: "12px",
                  padding: "16px",
                  borderRadius: "0px",
                  border: "none",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/user_testimonial.png",
                  alt: "Sasha L.",
                  styles: {
                    width: "212px",
                    height: "212px",
                    borderRadius: "50%",
                    border: "10.67px solid rgba(255, 255, 255, 1)",
                    objectFit: "cover",
                    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
                  },
                  responsiveStyles: {
                    tablet: {
                      width: "80px",
                      height: "80px",
                    },
                    mobile: {
                      width: "67px",
                      height: "67px",
                      border: "2px solid rgba(0, 0, 0, 0.05)",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: { flex: 1 },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: '"I quickly noticed a difference..."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontWeight: 700,
                        fontSize: "45px",
                        lineHeight: "40x",
                        marginBottom: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "28px",
                        },
                        mobile: {
                          fontSize: "28px",
                          lineHeight: "35px",
                          letterSpacing: "-0.28px",
                          marginBottom: "9.8px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0px",
                        marginBottom: "35px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "2px",
                        },
                        mobile: {
                          gap: "0px",
                          marginBottom: "16px",
                        },
                      },
                      children: [
                        ...Array(5)
                          .fill(null)
                          .map(() => ({
                            id: generateId(),
                            type: "image" as ElementType,
                            src: "/fortigold/star.svg",
                            alt: "star",
                            styles: { width: "48px", height: "48px" },
                            responsiveStyles: {
                              mobile: {
                                width: "22.29px",
                                height: "22.29px",
                              },
                            },
                          })),
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "Happy Customer",
                          styles: {
                            fontFamily: "Verdana, sans-serif",
                            fontWeight: 700,
                            fontSize: "32px",
                            color: "#FBBC04",
                            marginLeft: "25px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "18px",
                            },
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "-0.16px",
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        '"I felt the difference within days! My bloating disappeared, and I finally have energy that lasts all day."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontSize: "32px",
                        lineHeight: "40px",
                        letterSpacing: "-0.32px",
                        marginBottom: "35px",
                        color: "forground",
                        opacity: "0.8",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "28px",
                          letterSpacing: "-0.22px",
                          marginBottom: "16px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "12px",
                          alignItems: "flex-start",
                        },
                        mobile: {
                          gap: "6px",
                          alignItems: "center",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigold-bottle-quality-1.png",
                          alt: "Fortigold Bottles",
                          styles: {
                            width: "100px",
                            height: "50px",
                            objectFit: "contain",
                          },
                          responsiveStyles: {
                            tablet: {
                              width: "80px",
                              height: "80px",
                            },
                            mobile: {
                              width: "60px",
                              height: "60px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {},
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Sasha L., 35",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "40px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.4px",
                                marginBottom: "12px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "22px",
                                },
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.18px",
                                  marginBottom: "0",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "6 Bottles of Fortigold Bought",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "32px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.32px",
                                color: "primary",
                                margin: 0,
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "16px",
                                },
                                mobile: {
                                  fontSize: "14px",
                                  lineHeight: "20px",
                                  letterSpacing: "-0.14px",
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Review 2
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                background: "#fff",
                borderRadius: "24px",
                padding: "32px 24px",
                border: "4px solid rgba(0, 0, 0, 0.05)",
                color: "forground",
                display: "flex",
                gap: "30px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                tablet: {
                  gap: "18px",
                  padding: "15px",
                  borderRadius: "0px",
                },
                mobile: {
                  gap: "12px",
                  padding: "16px",
                  borderRadius: "0px",
                  border: "none",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/user_testimonial.png",
                  alt: "Sasha L.",
                  styles: {
                    width: "212px",
                    height: "212px",
                    borderRadius: "50%",
                    border: "10.67px solid rgba(255, 255, 255, 1)",
                    objectFit: "cover",
                    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
                  },
                  responsiveStyles: {
                    tablet: {
                      width: "80px",
                      height: "80px",
                    },
                    mobile: {
                      width: "67px",
                      height: "67px",
                      border: "2px solid rgba(0, 0, 0, 0.05)",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: { flex: 1 },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: '"I quickly noticed a difference..."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontWeight: 700,
                        fontSize: "45px",
                        lineHeight: "40x",
                        marginBottom: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "28px",
                        },
                        mobile: {
                          fontSize: "28px",
                          lineHeight: "35px",
                          letterSpacing: "-0.28px",
                          marginBottom: "9.8px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0px",
                        marginBottom: "35px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "2px",
                        },
                        mobile: {
                          gap: "0px",
                        },
                      },
                      children: [
                        ...Array(5)
                          .fill(null)
                          .map(() => ({
                            id: generateId(),
                            type: "image" as ElementType,
                            src: "/fortigold/star.svg",
                            alt: "star",
                            styles: { width: "48px", height: "48px" },
                            responsiveStyles: {
                              mobile: {
                                width: "22.29px",
                                height: "22.29px",
                              },
                            },
                          })),
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "Happy Customer",
                          styles: {
                            fontFamily: "Verdana, sans-serif",
                            fontWeight: 700,
                            fontSize: "32px",
                            color: "#FBBC04",
                            marginLeft: "25px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "18px",
                            },
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "-0.16px",
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        '"I felt the difference within days! My bloating disappeared, and I finally have energy that lasts all day."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontSize: "32px",
                        lineHeight: "40px",
                        letterSpacing: "-0.32px",
                        marginBottom: "35px",
                        color: "forground",
                        opacity: "0.8",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "28px",
                          letterSpacing: "-0.22px",
                          marginBottom: "16px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "12px",
                          alignItems: "flex-start",
                        },
                        mobile: {
                          gap: "6px",
                          alignItems: "center",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigold-bottle-quality-1.png",
                          alt: "Fortigold Bottles",
                          styles: {
                            width: "100px",
                            height: "50px",
                            objectFit: "contain",
                          },
                          responsiveStyles: {
                            tablet: {
                              width: "80px",
                              height: "80px",
                            },
                            mobile: {
                              width: "67px",
                              height: "67px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {},
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Sasha L., 35",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "40px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.4px",
                                marginBottom: "12px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "22px",
                                },
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.18px",
                                  marginBottom: "0",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "6 Bottles of Fortigold Bought",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "32px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.32px",
                                color: "primary",
                                margin: 0,
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "16px",
                                },
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "20px",
                                  letterSpacing: "-0.16px",
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Review 3
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                background: "#fff",
                borderRadius: "24px",
                padding: "32px 24px",
                border: "4px solid rgba(0, 0, 0, 0.05)",
                color: "forground",
                display: "flex",
                gap: "30px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                tablet: {
                  gap: "18px",
                  padding: "15px",
                  borderRadius: "0px",
                },
                mobile: {
                  gap: "12px",
                  padding: "16px",
                  borderRadius: "0px",
                  border: "none",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/user_testimonial.png",
                  alt: "Sasha L.",
                  styles: {
                    width: "212px",
                    height: "212px",
                    borderRadius: "50%",
                    border: "10.67px solid rgba(255, 255, 255, 1)",
                    objectFit: "cover",
                    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
                  },
                  responsiveStyles: {
                    tablet: {
                      width: "80px",
                      height: "80px",
                    },
                    mobile: {
                      width: "67px",
                      height: "67px",
                      border: "2px solid rgba(0, 0, 0, 0.05)",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: { flex: 1 },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: '"I quickly noticed a difference..."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontWeight: 700,
                        fontSize: "45px",
                        lineHeight: "40x",
                        marginBottom: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "28px",
                        },
                        mobile: {
                          fontSize: "28px",
                          lineHeight: "35px",
                          letterSpacing: "-0.28px",
                          marginBottom: "9.8px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0px",
                        marginBottom: "35px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "2px",
                        },
                        mobile: {
                          gap: "0px",
                        },
                      },
                      children: [
                        ...Array(5)
                          .fill(null)
                          .map(() => ({
                            id: generateId(),
                            type: "image" as ElementType,
                            src: "/fortigold/star.svg",
                            alt: "star",
                            styles: { width: "48px", height: "48px" },
                            responsiveStyles: {
                              mobile: {
                                width: "22.29px",
                                height: "22.29px",
                              },
                            },
                          })),
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "Happy Customer",
                          styles: {
                            fontFamily: "Verdana, sans-serif",
                            fontWeight: 700,
                            fontSize: "32px",
                            color: "#FBBC04",
                            marginLeft: "25px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "18px",
                            },
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "-0.16px",
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        '"I felt the difference within days! My bloating disappeared, and I finally have energy that lasts all day."',
                      styles: {
                        fontFamily: "Verdana, sans-serif",
                        fontSize: "32px",
                        lineHeight: "40px",
                        letterSpacing: "-0.32px",
                        marginBottom: "35px",
                        color: "forground",
                        opacity: "0.8",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "28px",
                          letterSpacing: "-0.22px",
                          marginBottom: "16px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      },
                      responsiveStyles: {
                        tablet: {
                          gap: "12px",
                          alignItems: "flex-start",
                        },
                        mobile: {
                          gap: "6px",
                          alignItems: "center",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/fortigold-bottle-quality-1.png",
                          alt: "Fortigold Bottles",
                          styles: {
                            width: "100px",
                            height: "50px",
                            objectFit: "contain",
                          },
                          responsiveStyles: {
                            tablet: {
                              width: "80px",
                              height: "80px",
                            },
                            mobile: {
                              width: "67px",
                              height: "67px",
                              border: "2px solid rgba(0, 0, 0, 0.05)",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {},
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Sasha L., 35",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "40px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.4px",
                                marginBottom: "12px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "22px",
                                },
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "28px",
                                  letterSpacing: "-0.22px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "6 Bottles of Fortigold Bought",
                              styles: {
                                fontFamily: "Verdana, sans-serif",
                                fontSize: "32px",
                                fontWeight: 700,
                                lineHeight: "40px",
                                letterSpacing: "-0.32px",
                                color: "primary",
                                margin: 0,
                              },
                              responsiveStyles: {
                                tablet: {
                                  fontSize: "16px",
                                },
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "20px",
                                  letterSpacing: "-0.16px",
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldLimitedSupplySection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "#005740",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "20px" },
    mobile: { padding: "13px 16px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1500px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "40px",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "column",
          textAlign: "center",
          gap: "25px",
        },
        mobile: {
          flexDirection: "column",
          textAlign: "center",
          gap: "0px",
          maxWidth: "100%",
        },
      },
      children: [
        // Badge
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "360px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "transparent",
              },
              responsiveStyles: {
                tablet: { width: "200px", height: "200px" },
                mobile: { width: "239px", height: "236px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/img_guranteed.png", // Use guarantee badge if available
                  alt: "Genuine Product Badge",
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                  responsiveStyles: {
                    tablet: { width: "200px", height: "200px" },
                    mobile: { width: "239px", height: "236px" },
                  },
                },
              ],
            },
          ],
        },
        // Text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            color: "secondary",
            maxWidth: "1055px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: `<span style="text-decoration:underline;color:${"secondary"};">Limited Supply Available</span> – <span style="color:#fcbc03;text-decoration:none;">Selling Out Fast!</span>`,
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "54px",
                lineHeight: "72px",
                textAlign: "center",
                letterSpacing: "-0.54px",
                marginBottom: "12px",
              },
              typography: "Heading-3",
              responsiveStyles: {
                tablet: {
                  fontSize: "32px",
                  lineHeight: "42px",
                  marginBottom: "12px",
                },
                mobile: {
                  fontSize: "27px",
                  lineHeight: "40px",
                  letterSpacing: "-0.27px",
                  marginBottom: "12px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Due to high demand, FORTIGOLD is selling out faster than expected. Once this batch is gone, restocking could take months.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "28px",
                lineHeight: "40px",
                textAlign: "center",
                letterSpacing: "-0.28px",
                margin: 0,
              },
              typography: "Body",
              responsiveStyles: {
                tablet: { fontSize: "22px", lineHeight: "32px" },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "32px",
                  letterSpacing: "-0.18px",
                  marginBottom: "32px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createPricingSection1 = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "#f9f9f9",
    padding: "90px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "40px 0" },
    mobile: { padding: "40px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1300px",
        margin: "0 auto",
        padding: "0 15px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "20px",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: { flexDirection: "column", alignItems: "center", gap: "14px" },
        mobile: { flexDirection: "column", alignItems: "center", gap: "14px" },
      },
      children: [
        // 1 Month Package
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "background",
            borderRadius: "12px",
            overflow: "hidden",
            border: "0.763px solid rgba(0,0,0,0.5)",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "45px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "2",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "2",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#D9D9D9",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Starter Package",
                  styles: {
                    margin: 0,
                    color: "#333",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "secondary",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "1 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#D6D6D6",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "background",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0 16px",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 0 20px 0",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 18px 0",
                        },
                        mobile: {
                          padding: "0 0 16px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 700,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px 0 0 0",
                        width: "100%",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                        mobile: {
                          margin: "0",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 0px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                        },
                        mobile: {
                          order: "3",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        // 6 Month Package (Most Popular)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "#FEFBF3",
            borderRadius: "12px",
            overflow: "hidden",
            border: "0.763px solid rgba(0,0,0,0.5)",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "0px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "1",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "1",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#DE9B03",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Starter Package",
                  styles: {
                    margin: 0,
                    color: "secondary",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/rating.png",
                  alt: "Rating Image",
                  styles: {
                    maxWidth: "100px",
                    margin: "0 auto",
                    width: "100%",
                    height: "auto",
                    display: "none",
                  },
                  responsiveStyles: {
                    tablet: { display: "block" },
                    mobile: { display: "block" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "secondary",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "1 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#DE9B03",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/rating.png",
                  alt: "Rating Image",
                  styles: {
                    maxWidth: "190px",
                    width: "100%",
                    height: "auto",
                    display: "block",
                  },
                  responsiveStyles: {
                    tablet: { display: "none" },
                    mobile: { display: "none" },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 16px 20px",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 10px 0",
                        },
                        mobile: {
                          padding: "0 0 6px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 900,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px auto 0",
                        width: "calc(100% - 32px)",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0 auto",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "calc(100% - 20px)",
                        },
                        mobile: {
                          margin: "0 auto",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "calc(100% - 12px)",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 16px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                          padding: "10px 10px",
                        },
                        mobile: {
                          order: "3",
                          padding: "10px 6px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    // Shipping badge
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "100%",
                        height: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage:
                          "linear-gradient(90deg, #3C3835 0%, #645C5A 51%, #32302D 100%)",
                        color: "secondary",
                        padding: "6px 16px",
                        fontWeight: 600,
                        fontSize: "20px",
                        margin: "10px 0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 10px",
                          borderRadius: "13px",
                          width: "calc(100% - 20px)",
                          margin: "10px auto",
                          height: "30px",
                        },
                        mobile: {
                          padding: "0 6px",
                          borderRadius: "13px",
                          width: "calc(100% - 12px)",
                          margin: "10px auto",
                          height: "30px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-shipping.svg",
                          alt: "shipping",
                          styles: {
                            width: "48.085px",
                            height: "48.085px",
                            marginRight: "10px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "Free US Shipping",
                          styles: {
                            color: "secondary",
                            fontWeight: 600,
                            fontSize: "20px",
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "16px",
                            },
                            mobile: {
                              fontSize: "12px",
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px auto 0",
                          width: "calc(100% - 20px)",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px auto 0",
                          width: "calc(100% - 12px)",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        // 3 Month Package
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "background",
            borderRadius: "12px",
            overflow: "hidden",
            border: "0.763px solid rgba(0,0,0,0.5)",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "45px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "3",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "3",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#D9D9D9",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Starter Package",
                  styles: {
                    margin: 0,
                    color: "#333",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "secondary",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "1 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#D6D6D6",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "background",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0 16px",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 0 20px 0",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 18px 0",
                        },
                        mobile: {
                          padding: "0 0 16px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 700,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px 0 0 0",
                        width: "100%",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                        mobile: {
                          margin: "0",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 0px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                        },
                        mobile: {
                          order: "3",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldGuaranteeCertificateSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "primary",
    padding: "95px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    position: "relative",
  },
  responsiveStyles: {
    tablet: { padding: "37px 20px" },
    mobile: { padding: "27px 16px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        width: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
      },
      responsiveStyles: {
        mobile: {
          maxWidth: "100%",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            borderRadius: "18px",
            backgroundColor: "#F1EEE7",
            padding: "20px 19px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          },
          responsiveStyles: {
            mobile: { padding: "8px" },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                border: "8px solid primary",
                borderRadius: "18px",
                padding: "33px 70px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "29px 0",
                background: "#F1EEE7",
              },
              responsiveStyles: {
                mobile: {
                  padding: "13px 15px",
                  gap: "0",
                  border: "4px solid primary",
                },
              },
              children: [
                // Header
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "GUARANTEE CERTIFICATE",
                  styles: {
                    color: "forground",
                    textAlign: "center",
                    fontFamily: "Times New Roman, sans-serif",
                    fontSize: "65px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "93.325px",
                    letterSpacing: "-1.95px",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "45px", lineHeight: "45px" },
                    mobile: {
                      fontSize: "25px",
                      lineHeight: "84px",
                      letterSpacing: "-0.75px",
                      marginBottom: "4.53px",
                    },
                  },
                },
                // Body
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0,
                  },
                  children: [
                    // List
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "26px 0",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                      },
                      responsiveStyles: {
                        tablet: { gap: "20px 0" },
                        mobile: { gap: "8px 0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: `This certificate confirms that your order of FortiGold is backed by our <b style='color:${"forground"};'>100% Money-Back Guarantee</b> for 60 days from the date of purchase.`,
                          styles: {
                            color: "forground",
                            opacity: "0.6",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "30px",
                            fontWeight: 400,
                            lineHeight: "40px",
                            letterSpacing: "-0.3px",
                            textAlign: "center",
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "22px", lineHeight: "35px" },
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "27px",
                              letterSpacing: "-0.16px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "If you are not satisfied for any reason - whether you don't feel the improvement in digestion, energy, or clarity - you are entitled to a full refund.",
                          styles: {
                            color: "forground",
                            opacity: "0.6",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "30px",
                            fontWeight: 400,
                            lineHeight: "40px",
                            letterSpacing: "-0.3px",
                            textAlign: "center",
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: { fontSize: "22px", lineHeight: "35px" },
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "27px",
                              letterSpacing: "-0.16px",
                            },
                          },
                        },
                      ],
                    },
                    // Signature
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        maxWidth: "277px",
                        width: "100%",
                        marginTop: "32px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        justifyContent: "center",
                      },
                      responsiveStyles: {
                        tablet: { maxWidth: "224px" },
                        mobile: { maxWidth: "180px", marginTop: "4.53px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/gurantee-signature.png",
                          alt: "Gurantee-signature",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          },
                        },
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/signature1.png",
                          alt: "signature",
                          styles: {
                            maxWidth: "300px",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createVipBonusesSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "#F7F7F7",
    padding: "80px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "50px 0" },
    mobile: { padding: "70px 0 30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        margin: "0 auto",
        padding: "0 15px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      children: [
        // Header
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            marginBottom: "130px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: { marginBottom: "80px" },
            mobile: { marginBottom: "20px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                'Exclusive VIP Bonuses – <span style="text-decoration:underline;">FREE With Your Order Today!</span>',
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "64px",
                lineHeight: "72px",
                color: "forground",
                margin: "0 auto 20px auto",
                maxWidth: "1138px",
                letterSpacing: "-1.92px",
              },
              typography: "Heading-2",
              responsiveStyles: {
                tablet: { fontSize: "36px" },
                mobile: {
                  fontSize: "38px",
                  lineHeight: "48px",
                  letterSpacing: "-1.14px",
                  marginBottom: "13px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: `Get <span style="color:${"forground"};">instant access</span> to these <span style="color:${"forground"};">powerful guides</span> designed to help you <span style="color:${"forground"};">boost energy, sharpen your mind, and optimize your health—at no extra cost!</span>`,
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                lineHeight: "40px",
                color: "forground",
                opacity: "0.6",
                maxWidth: "1138px",
                letterSpacing: "-0.28px",
                margin: "0 auto",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "22px",
                  lineHeight: "37px",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
        // Bonus Cards
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            },
            mobile: {
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            },
          },
          children: [
            // Bonus Card 1
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                background: "transparent",
                borderRadius: "12px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                overflow: "hidden",
                maxWidth: "663px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                border: "5px solid primary",
                padding: "28px 22px",
              },
              responsiveStyles: {
                mobile: {
                  maxWidth: "100%",
                  padding: "14px",
                  border: "2.88px solid primary",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: { borderRadius: "16px" },
                  children: [
                    // Image
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        height: "400px",
                        backgroundColor: "#eaeaea",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "16px 16px 0 0",
                        overflow: "hidden",
                        position: "relative",
                      },
                      responsiveStyles: {
                        mobile: { height: "218px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/book1.png",
                          alt: "Wake Up Energized Bonus",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "16px 16px 0 0",
                          },
                          responsiveStyles: {
                            mobile: {
                              width: "100%",
                              height: "281px",
                              objectFit: "cover",
                              borderRadius: "9.21px 9.21px 0 0",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/digistore24.svg",
                          alt: "Digital Download",
                          styles: {
                            position: "absolute",
                            bottom: "10px",
                            right: "8px",
                            width: "100px",
                            height: "auto",
                          },
                        },
                      ],
                    },
                    // Content
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                      },
                      children: [
                        // Label
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "28px",
                            color: "secondary",
                            padding: "10px",
                            backgroundImage:
                              "linear-gradient(89deg, #00573F 40.18%, #869C2D 102.91%)",
                            textAlign: "center",
                          },
                          responsiveStyles: {
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "-0.48px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: `<span style="color:#FFE927;">Bonus #1</span> - Wake Up Energized`,
                              styles: {
                                margin: "0 50px",
                                fontSize: "28px",
                                letterSpacing: "-0.84px",
                                lineHeight: "40px",
                                fontWeight: 600,
                                color: "background",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.48px",
                                  margin: "0 20px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "The revolutionary gut fix for mental fog & all-day focus",
                              styles: {
                                margin: "0 60px",
                                fontSize: "28px",
                                letterSpacing: "-0.84px",
                                color: "background",
                                lineHeight: "40px",
                                fontWeight: 600,
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.48px",
                                  margin: "0 30px",
                                },
                              },
                            },
                          ],
                        },
                        // Price
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#000",
                            color: "secondary",
                            fontSize: "30px",
                            fontWeight: 700,
                            justifyContent: "center",
                            padding: "10px",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "22px", padding: "19px" },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$67",
                              styles: {
                                fontFamily: "Roboto sans-serif",
                                textDecoration: "line-through",
                                color: "background",
                                margin: 0,
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "26.68px",
                                  lineHeight: "26.47px",
                                  letterSpacing: "-0.53px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: `<span style="color:#FFFFFF;opacity:0.6;font-weight:400;">Today:</span> FREE`,
                              styles: {
                                fontFamily: "SF Pro Display, sans-serif",
                                fontWeight: 900,
                                color: "background",
                                margin: 0,
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "26.68px",
                                  lineHeight: "26.47px",
                                  letterSpacing: "-0.53px",
                                },
                              },
                            },
                          ],
                        },
                        // Description
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Discover the 7-day morning reset that eliminates sluggishness and helps you start every day full of energy—without coffee crashes!",
                          styles: {
                            fontFamily: "Roboto, sans-serif",
                            fontSize: "33px",
                            lineHeight: "46px",
                            letterSpacing: "-0.33px",
                            color: "forground",
                            opacity: "0.6",
                            backgroundColor: "background",
                            flexGrow: 1,
                            padding: "20px",
                            textAlign: "center",
                            borderRadius: "0 0 16px 16px",
                          },
                          responsiveStyles: {
                            mobile: {
                              fontSize: "22px",
                              lineHeight: "30px",
                              letterSpacing: "-0.22px",
                              padding: "24px 10px",
                            },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Bonus Card 2
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                background: "transparent",
                borderRadius: "12px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                overflow: "hidden",
                maxWidth: "663px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                border: "5px solid primary",
                padding: "28px 22px",
              },
              responsiveStyles: {
                mobile: {
                  maxWidth: "100%",
                  padding: "14px",
                  border: "2.88px solid primary",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: { borderRadius: "16px" },
                  children: [
                    // Image
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        height: "400px",
                        backgroundColor: "#eaeaea",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "16px 16px 0 0",
                        overflow: "hidden",
                        position: "relative",
                      },
                      responsiveStyles: {
                        mobile: { height: "218px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/book2.png",
                          alt: "Brain Boost Secrets Bonus",
                          styles: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "16px 16px 0 0",
                          },
                        },
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/digistore24.svg",
                          alt: "Digital Download",
                          styles: {
                            position: "absolute",
                            bottom: "10px",
                            right: "8px",
                            width: "100px",
                            height: "auto",
                          },
                        },
                      ],
                    },
                    // Content
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                      },
                      children: [
                        // Label
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: "28px",
                            color: "secondary",
                            padding: "10px",
                            backgroundImage:
                              "linear-gradient(89deg, #00573F 40.18%, #869C2D 102.91%)",
                            textAlign: "center",
                          },
                          responsiveStyles: {
                            mobile: {
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "-0.48px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: `<span style="color:#FFE927;">Bonus #2</span> - The Genius Code`,
                              styles: {
                                margin: "0 60px",
                                fontSize: "28px",
                                letterSpacing: "-0.84px",
                                lineHeight: "40px",
                                fontWeight: 600,
                                color: "background",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.48px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Created with famous brain expert Dr. Reynolds Eichmann.",
                              styles: {
                                margin: "0 50px",
                                fontSize: "28px",
                                letterSpacing: "-0.84px",
                                lineHeight: "40px",
                                fontWeight: 600,
                                color: "background",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                  letterSpacing: "-0.48px",
                                },
                              },
                            },
                          ],
                        },
                        // Price
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#000",
                            color: "secondary",
                            fontSize: "30px",
                            fontWeight: 700,
                            justifyContent: "center",
                            padding: "10px",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "22px", padding: "19px" },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$47",
                              styles: {
                                fontFamily: "Roboto sans-serif",
                                textDecoration: "line-through",
                                color: "background",
                                margin: 0,
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "26.68px",
                                  lineHeight: "26.47px",
                                  letterSpacing: "-0.53px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: `<span style="color:#FFFFFF;opacity:0.6;font-weight:400;">Today:</span> FREE`,
                              styles: {
                                fontFamily: "SF Pro Display, sans-serif",
                                fontWeight: 900,
                                color: "background",
                                margin: 0,
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "26.68px",
                                  lineHeight: "26.47px",
                                  letterSpacing: "-0.53px",
                                },
                              },
                            },
                          ],
                        },
                        // Description
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "These are same techniques that world champions use, but made easy so anyone can unlock their brains full potential.",
                          styles: {
                            fontFamily: "Roboto, sans-serif",
                            fontSize: "33px",
                            lineHeight: "46px",
                            letterSpacing: "-0.33px",
                            color: "forground",
                            opacity: "0.6",
                            backgroundColor: "background",
                            flexGrow: 1,
                            padding: "20px",
                            textAlign: "center",
                            borderRadius: "0 0 16px 16px",
                          },
                          responsiveStyles: {
                            mobile: {
                              fontSize: "22px",
                              lineHeight: "30px",
                              letterSpacing: "-0.22px",
                              padding: "24px 10px",
                            },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldFAQSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "background",
    padding: "80px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  responsiveStyles: {
    tablet: { padding: "20px 0" },
    mobile: { padding: "20px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1270px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      responsiveStyles: {
        mobile: {
          maxWidth: "100%",
        },
      },
      children: [
        // Section Title
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            marginBottom: "48px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: { marginBottom: "20px" },
            mobile: { marginBottom: "16px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Frequently Asked Questions ",
              styles: {
                fontSize: "64px",
                color: "forground",
                opacity: "0.9",
                marginBottom: "15px",
                fontWeight: 900,
                fontFamily: "Roboto, sans-serif",
              },
              typography: "Heading-2",
              responsiveStyles: {
                tablet: { fontSize: "38px" },
                mobile: {
                  fontSize: "38px",
                  lineHeight: "48px",
                  letterSpacing: "-1.14px",
                  marginBottom: "0px",
                },
              },
            },
          ],
        },
        // FAQ Container
        {
          id: generateId(),
          type: "accordion" as ElementType,
          allowMultiple: false,
          defaultOpen: false,
          itemBorder: "1px solid rgba(0, 0, 0, 0.20)",
          accordionType: "single" as "single" | "multiple",
          // Icon configuration for all accordion items
          iconSrcCollapsed: "/fortigold/arrow-right-circle.svg",
          iconSrcExpanded: "/fortigold/arrow-right-circle.svg",
          // Icon styling
          iconStyles: {
            width: "46px",
            height: "47px",
            marginLeft: "16px",
          },
          styles: {
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            border: "0",
            padding: "0px 24px",
          },
          responsiveStyles: {
            tablet: { maxWidth: "95%" },
            mobile: { maxWidth: "100%" },
          },
          children: [
            // FAQ Items
            ...[
              {
                q: "What exactly is FortiGold and how does it work?",
                a: "FortiGold is a premium, doctor-formulated gut health supplement made from first-milking colostrum also known as \"nature's golden liquid.\" It's packed with protective antibodies, growth factors, and over 40x the active nutrients of ordinary supplements. In just one scoop a day, it helps rebuild your gut lining, eliminate toxins, strengthen your immune system, and helps restore your natural energy—starting in just 72 hours.",
              },
              {
                q: "How fast can I expect to feel a difference?",
                a: "Many users report feeling more energy, less bloating, and better digestion in the first 3 days. Most dramatic transformations happen around 3 weeks to 3 months, depending on the level of gut damage. Our research shows FortiGold starts supporting the repair of your gut barrier in as little as 72 hours and keeps getting better from there.",
              },
              {
                q: "Is FortiGold safe to take every day?",
                a: "Absolutely. FortiGold is 100% natural, non-GMO, gluten-free, stimulant-free, and non-habit forming. It's manufactured in an FDA-registered, GMP-certified facility and triple-tested for purity and safety. You can safely take it every day for long-term support.",
              },
              {
                q: "I've tried probiotics and gut supplements before. How is FortiGold different?",
                a: "Probiotics often act like band-aids. FortiGold is the only formula that help seals, heals, and strengthens your gut lining using nature's most complete healing package: immunoglobulins (antibodies), growth factors, and bioavailable nutrients. It's not just relief—it's real, lasting repair.",
              },
              {
                q: "What kind of results are people getting?",
                a: 'Countless people have experienced life-changing transformations: better digestion, more energy, sharper focus, glowing skin, fewer sick days, and renewed confidence. People say things like "my brain fog disappeared," "I finally feel like myself again," and "this saved my life."',
              },
              {
                q: "Will this help with bloating, weight gain, or brain fog?",
                a: "Yes. FortiGold was specifically designed to help eliminate bloating, rebalance metabolism for easier weight loss, and reduce inflammation that causes brain fog and fatigue. When your gut barrier is restored, everything else improves—naturally.",
              },
              {
                q: "What if it doesn't work for me?",
                a: "That's okay. We stand behind FortiGold with a 60-day, 100% money-back guarantee. If you don't see real results—more energy, clearer thinking, better digestion—you can get a full refund. No hassle, no questions asked.",
              },
              {
                q: "How do I take it, and does it taste good?",
                a: "Just one scoop mixed with water, coffee, or a smoothie in the morning. That's it. Most customers say it tastes creamy and smooth, and some even add it to their pancakes or oatmeal like Sarah did in her story.",
              },
              {
                q: "What's the best package to order for full results?",
                a: "The 6-month package is the most popular because it helps give your gut time to fully repair and rebuild its protective barrier. Plus, it comes with free shipping, bonus guides, and a private strategy session. It also gives you the lowest price per bottle—just $49.",
              },
              {
                q: "Why is FortiGold selling out so fast?",
                a: "Because it's backed by real science, it works, and the demand is exploding. Each batch is made with premium colostrum using a cold-filtration process that preserves all healing compounds—which limits supply. Once it's gone, it could take months to restock.",
              },
            ].map((item, idx) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                padding: "0",
                marginBottom: "32px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexDirection: "column",
                gap: "32px ",
                width: "100%",
                border: "0",
                position: "relative", // Added for absolute positioned icon
              },
              responsiveStyles: {
                tablet: {
                  marginBottom: "0px",
                  padding: "24px 16px",
                  gap: "24px",
                },
                mobile: {
                  marginBottom: "0px",
                  padding: "6px 16px",
                  gap: "18px",
                },
              },
              children: [
                // Simple question heading
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  accordionRole: "question" as const,
                  content: item.q,
                  styles: {
                    margin: 0,
                    padding: "0px 24px",
                    // border: "1px solid rgba(0,0,0,0.20)",
                    backgroundColor: "#F7F7F7",
                    borderRadius: "16px",
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    cursor: "pointer",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    fontSize: "32px",
                    color: "#393939",
                  },
                  responsiveStyles: {
                    tablet: {
                      height: "80px",
                      fontSize: "18px",
                      padding: "0px 8px",
                    },
                    mobile: {
                      height: "80px",
                      fontSize: "14px",
                      lineHeight: "20px",
                      padding: "0px 8px",
                      letterSpacing: "-0.42px",
                    },
                  },
                },
                // Answer element with accordion role
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  accordionRole: "answer" as const,
                  content: item.a,
                  styles: {
                    margin: 0,
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "24px",
                    color: "forground",
                    opacity: "0.6",
                    width: "100%",
                    padding: "0px 10px",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "14px" },
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createFortigoldLimitedSupplySection1 = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "#005740",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "20px" },
    mobile: { padding: "20px 10px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1300px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "40px",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "column",
          textAlign: "center",
          gap: "25px",
        },
        mobile: {
          flexDirection: "column",
          textAlign: "center",
          gap: "25px",
        },
      },
      children: [
        // Badge
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "360px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "transparent",
              },
              responsiveStyles: {
                tablet: { width: "200px", height: "200px" },
                mobile: { width: "200px", height: "200px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/img_guranteed.png", // Use guarantee badge if available
                  alt: "Genuine Product Badge",
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                  responsiveStyles: {
                    tablet: { width: "200px", height: "200px" },
                    mobile: { width: "200px", height: "200px" },
                  },
                },
              ],
            },
          ],
        },
        // Text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            color: "secondary",
            maxWidth: "1055px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: `<span style="text-decoration:underline;color:${"secondary"};">Limited Supply Available</span> – <span style="color:#fcbc03;text-decoration:none;">Selling Out Fast!</span>`,
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "36px",
                lineHeight: "72px",
                textAlign: "center",
                letterSpacing: "-0.54px",
                margin: 0,
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "32px",
                  lineHeight: "42px",
                  marginBottom: "12px",
                },
                mobile: {
                  fontSize: "24px",
                  lineHeight: "32px",
                  marginBottom: "12px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Due to high demand, FORTIGOLD is selling out faster than expected. Once this batch is gone, restocking could take months.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "22px",
                lineHeight: "40px",
                textAlign: "center",
                letterSpacing: "-0.28px",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "22px", lineHeight: "32px" },
                mobile: { fontSize: "18px", lineHeight: "28px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createPricingSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "#f9f9f9",
    padding: "90px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "40px 0" },
    mobile: { padding: "40px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1300px",
        margin: "0 auto",
        padding: "0 15px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "20px",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: { flexDirection: "column", alignItems: "center", gap: "14px" },
        mobile: { flexDirection: "column", alignItems: "center", gap: "14px" },
      },
      children: [
        // 1 Month Package
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "background",
            borderRadius: "12px",
            overflow: "hidden",
            border: "0.763px solid rgba(0,0,0,0.5)",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "45px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "2",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "2",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#D9D9D9",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Starter Package",
                  styles: {
                    margin: 0,
                    color: "#333",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "background",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "1 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#D6D6D6",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "background",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0 16px",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 0 20px 0",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 18px 0",
                        },
                        mobile: {
                          padding: "0 0 16px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 700,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px 0 0 0",
                        width: "100%",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                        mobile: {
                          margin: "0",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 0px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                        },
                        mobile: {
                          order: "3",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        // 6 Month Package (Most Popular)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "#FEFBF3",
            borderRadius: "12px",
            overflow: "hidden",
            border: "3.6261px solid primary",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "0px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "1",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "1",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#DE9B03",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "MOST POPULAR",
                  styles: {
                    margin: 0,
                    color: "background",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/rating.png",
                  alt: "Rating Image",
                  styles: {
                    maxWidth: "100px",
                    margin: "0 auto",
                    width: "100%",
                    height: "auto",
                    display: "none",
                  },
                  responsiveStyles: {
                    tablet: { display: "block" },
                    mobile: { display: "block" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "background",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "6 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#DE9B03",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/rating.png",
                  alt: "Rating Image",
                  styles: {
                    maxWidth: "190px",
                    width: "100%",
                    height: "auto",
                    display: "block",
                  },
                  responsiveStyles: {
                    tablet: { display: "none" },
                    mobile: { display: "none" },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 16px 20px",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 10px 0",
                        },
                        mobile: {
                          padding: "0 0 6px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 900,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px auto 0",
                        width: "calc(100% - 32px)",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0 auto",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "calc(100% - 20px)",
                        },
                        mobile: {
                          margin: "0 auto",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "calc(100% - 12px)",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 16px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                          padding: "10px 10px",
                        },
                        mobile: {
                          order: "3",
                          padding: "10px 6px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    // Shipping badge
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        width: "100%",
                        height: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage:
                          "linear-gradient(90deg, #3C3835 0%, #645C5A 51%, #32302D 100%)",
                        color: "secondary",
                        padding: "6px 16px",
                        fontWeight: 600,
                        fontSize: "20px",
                        margin: "10px 0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 10px",
                          borderRadius: "13px",
                          width: "calc(100% - 20px)",
                          margin: "10px auto",
                          height: "30px",
                        },
                        mobile: {
                          padding: "0 6px",
                          borderRadius: "13px",
                          width: "calc(100% - 12px)",
                          margin: "10px auto",
                          height: "30px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-shipping.svg",
                          alt: "shipping",
                          styles: {
                            width: "48.085px",
                            height: "48.085px",
                            marginRight: "10px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "Free US Shipping",
                          styles: {
                            color: "background",
                            fontWeight: 600,
                            fontSize: "28px",
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "16px",
                            },
                            mobile: {
                              fontSize: "12px",
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px auto 0",
                          width: "calc(100% - 20px)",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px auto 0",
                          width: "calc(100% - 12px)",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        // 3 Month Package
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "410px",
            backgroundColor: "background",
            borderRadius: "12px",
            overflow: "hidden",
            border: "0.763px solid rgba(0,0,0,0.5)",
            boxShadow:
              "-3.817px 3.817px 11.45px 3.817px rgba(0,0,0,0.12), 3.817px 3.817px 9.923px 0px rgba(0,0,0,0.10)",
            transition: "all 0.3s ease",
            marginTop: "45px",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
          },
          responsiveStyles: {
            tablet: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "3",
            },
            mobile: {
              width: "100%",
              maxWidth: "100%",
              marginTop: "0px",
              order: "3",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#D9D9D9",
                padding: "10px 0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { display: "block", padding: "10px 0" },
                mobile: { display: "block", padding: "10px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Advanced Package",
                  styles: {
                    margin: 0,
                    color: "forground",
                    fontSize: "24px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, #373330 0%, #655D5B 53%, #2E2D29 100%)",
                color: "background",
                textAlign: "center",
                padding: "6px 12px",
                fontSize: "24px",
                fontWeight: 600,
                display: "block",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              content: "3 MONTH PACKAGE",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                justifyContent: "center",
                padding: "8px 0 20px 0",
                backgroundColor: "#D6D6D6",
                minHeight: "50px",
                position: "relative",
                overflow: "hidden",
              },
              responsiveStyles: {
                tablet: { display: "none" },
                mobile: { display: "none" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "650px",
                    height: "100px",
                    backgroundColor: "background",
                    borderRadius: "100%",
                    position: "absolute",
                    bottom: "-89px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                alignItems: "center",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "16px",
                },
                mobile: {
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px",
                },
              },
              children: [
                // Section header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "20px 0",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "10px 0",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "1 MONTH PACKAGE",
                      styles: {
                        color: "forground",
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "none",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                        mobile: {
                          fontSize: "22px",
                          lineHeight: "20px",
                          display: "block",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        margin: "-30px 0px 12px",
                        zIndex: "9",
                      },
                      responsiveStyles: {
                        tablet: { margin: "12px 0 0" },
                        mobile: { margin: "0" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-bottle-1.webp",
                          alt: "FortiGold 1 Month Package",
                          styles: {
                            maxWidth: "285px",
                            width: "100%",
                            height: "auto",
                          },
                          responsiveStyles: {
                            tablet: { maxWidth: "250px" },
                            mobile: { maxWidth: "150px" },
                          },
                        },
                      ],
                    },
                  ],
                },
                // Price and CTA
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0 16px",
                  },
                  responsiveStyles: {
                    tablet: {
                      display: "flex",
                      width: "calc(50% - 8px)",
                      padding: "10px",
                      alignItems: "flex-start",
                    },
                    mobile: {
                      display: "flex",
                      width: "calc(50% - 4px)",
                      padding: "6px",
                      alignItems: "flex-start",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "0 0 20px 0",
                        order: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          padding: "0 0 18px 0",
                        },
                        mobile: {
                          padding: "0 0 16px 0",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: {
                            color: "#38b349",
                            fontSize: "85px",
                            fontWeight: 700,
                            lineHeight: 1,
                            margin: 0,
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "52px",
                            },
                            mobile: {
                              fontSize: "42px",
                            },
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            color: "#333",
                            fontSize: "22px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            gap: "4px",
                          },
                          responsiveStyles: {
                            tablet: {
                              fontSize: "14px",
                            },
                            mobile: {
                              fontSize: "10px",
                            },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PER",
                              styles: { lineHeight: 1 },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "BOTTLE",
                              styles: { lineHeight: 1 },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "BUY NOW",
                      styles: {
                        display: "block",
                        backgroundImage:
                          "linear-gradient(to bottom, #FFE927 50%, #FFDB00 50%)",
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        padding: "15px 25px",
                        border: "3.626px solid #BA6500",
                        borderRadius: "12px",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.2)",
                        margin: "10px 0 0 0",
                        width: "100%",
                        order: "1",
                      },
                      responsiveStyles: {
                        tablet: {
                          margin: "0",
                          fontSize: "20px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                        mobile: {
                          margin: "0",
                          fontSize: "15px",
                          height: "40px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "10px 0px",
                        width: "100%",
                        order: "2",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "3",
                        },
                        mobile: {
                          order: "3",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/fortigold/dummy-payment.png",
                          alt: "Payment",
                          styles: { width: "100%" },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        textAlign: "center",
                        fontSize: "20px",
                        padding: "10px 0 35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        order: "3",
                      },
                      responsiveStyles: {
                        tablet: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "16px",
                          height: "30px",
                          gap: "10px",
                        },
                        mobile: {
                          order: "2",
                          padding: "0",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          borderRadius: "12px",
                          margin: "16px 0 0",
                          width: "100%",
                          fontSize: "12px",
                          height: "30px",
                          gap: "8px",
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "TOTAL: ",
                          styles: { color: "#333", fontWeight: 400 },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            textAlign: "center",
                            position: "relative",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "$89",
                              styles: { color: "#333", fontWeight: 400 },
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                backgroundColor: "#E5102E",
                                width: "42px",
                                height: "1.5px",
                                position: "absolute",
                                display: "block",
                                transform: "rotate(145deg)",
                                top: "16px",
                              },
                              responsiveStyles: {
                                tablet: {
                                  top: "10px",
                                  width: "28px",
                                },
                                mobile: {
                                  top: "10px",
                                  width: "24px",
                                },
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content: "$69",
                          styles: { color: "#333", fontWeight: 800 },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "72px 0 36px 0" },
    mobile: { padding: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "forground",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createScientificRefListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "60px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "32px 0" },
    mobile: { padding: "24px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px", maxWidth: "95%" },
        mobile: { gap: "12px", maxWidth: "95%" },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
          },
          responsiveStyles: {
            tablet: { gap: "18px", flexDirection: "column" },
            mobile: { gap: "12px", flexDirection: "column" },
          },
          children: [
            // First Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
            // Second Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 40px",

            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",

                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              typography: "Heading-6",
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",

                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              typography: "Heading-6",
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                typography: "Heading-6",
                fontStyle: "normal",

                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              typography: "Heading-6",
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",

                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              typography: "Heading-6",
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup: "fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",

                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              typography: "Heading-6",

              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",

                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              typography: "Heading-6",
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "background",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "forground",
            opacity: "0.6",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.28px",
          },
          typography: "Body",
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "forground",
            opacity: "0.6",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.28px",
          },
          typography: "Body",
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "forground",
            opacity: "0.6",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

const createVidalyticsVideoElement = (
  embedId: string,
  playerEvents?: {
    play?: () => void;
    pause?: () => void;
    ended?: () => void;
  }
): import("../types/builder").BuilderElement => ({
  id: generateId(),
  type: "vidalytics-video" as ElementType,
  landscapeEmbedId: "vidalytics_embed_VH2uniHUgWRJO9u2",
  verticalEmbedId: "vidalytics_embed_4HFbPROMKa5i5957",
  landscapeUrl: "https://fast.vidalytics.com/embeds/hfwrJKPS/VH2uniHUgWRJO9u2/",
  verticalUrl: "https://fast.vidalytics.com/embeds/hfwrJKPS/4HFbPROMKa5i5957/",
  playerEvents,
  styles: {
    border: "4.584px solid #FFF",
    boxShadow: "0px 0px 25px 1px #FBBC04",
    backgroundColor: "#000",
    display: "block",
    width: "100%",
    maxWidth: "1200px",
    minHeight: "360px",
    maxHeight: "700px",
    margin: "0 auto",
    position: "relative",
    overflow: "hidden",
  },
});

const vslVideoSectionContainer = () => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#77a686d9",
    margin: 0,
    padding: "24px 0 44px",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "24px",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "6px",
            justifyContent: "center",
            alignItems: "center",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                'This <span style="color:#fbbc04;">Golden Liquid Is Going</span> Viral..',
              styles: {
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                fontSize: "60px",
                fontWeight: "700",
                color: "#fff",
                margin: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "40px",
                },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                'But Doctors Are Staying <span style="color:#e34444;">Silent!</span>',
              styles: {
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                fontSize: "60px",
                fontWeight: "700",
                color: "#fff",
                margin: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "40px",
                },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
          ],
        },
        createVidalyticsVideoElement("vidalytics_embed_y8vfbXPEZPB92eV9", {
          play: () => console.log("Video played!"),
          pause: () => console.log("Video paused!"),
          ended: () => console.log("Video ended!"),
        }),
      ],
    },
  ],
});

const vslClaimTimerSectionContainer = () => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: true,
  styles: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `radial-gradient(circle at 1008px 552px, #242424 9.13%, #137F42 100%)`,
    margin: 0,
    padding: "102px 0 66px",
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content:
        '<span style="text-decoration: underline;">CLAIM YOUR DISCOUNT</span> – <span style="color:#FBBC04;">Selling Out Fast!</span>',
      styles: {
        fontSize: "54px",
        fontWeight: "900",
        color: "#fff",
        margin: "0",
        textAlign: "center",
      },
      typography: "Heading-3",
    },
    {
      id: generateId(),
      type: "paragraph" as ElementType,
      content:
        "Due to high demand, FORTIGOLD is selling out faster than expected. Once this batch is gone, restocking could take months.",
      styles: {
        maxWidth: "1040px",
        fontSize: "29px",
        fontWeight: "400",
        color: "#fff",
        margin: "0",
        textAlign: "center",
      },
    },
    {
      id: generateId(),
      type: "timer" as ElementType,
      countdownTimerSeconds: 1800,
      styles: {
        fontSize: "60px",
        fontWeight: "700",
        color: "#ff0000",
        margin: "24px 0 0",
        textAlign: "center",
      },
    },
  ],
});

export const template1Template = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    embededVideo: createVidalyticsVideoElement(
      "vidalytics_embed_y8vfbXPEZPB92eV9",
      {
        play: () => console.log("Video played!"),
        pause: () => console.log("Video paused!"),
        ended: () => console.log("Video ended!"),
      }
    ),
    firstSection: createFirstSectionContainer(globalConfig),
    fortigoldFeatureSection: createFortigoldFeatureSection(globalConfig),
    healthSolutionSection: createHealthSolutionSection(globalConfig),
    fortigoldWorksSection: createFortigoldWorksSection(globalConfig),
    fortigoldGutHealthSection: createFortigoldGutHealthSection(globalConfig),
    fortigoldTestimonialsSection:
      createFortigoldTestimonialsSection(globalConfig),
    fortigoldLimitedSupplySection:
      createFortigoldLimitedSupplySection(globalConfig),
    pricingSection1: createPricingSection(globalConfig),
    fortigoldGuaranteeCertificateSection:
      createFortigoldGuaranteeCertificateSection(globalConfig),
    vipBonusesSection: createVipBonusesSection(globalConfig),
    fortigoldFAQSection: createFortigoldFAQSection(globalConfig),
    fortigoldLimitedSupplySection1:
      createFortigoldLimitedSupplySection(globalConfig),
    pricingSection: createPricingSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};

export const template1VSLTemplate = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    embededVideo: vslVideoSectionContainer(),
    claimTimerSection: vslClaimTimerSectionContainer(),
    pricingSection2: createPricingSection(globalConfig, true),
    fortigoldFeatureSection: createFortigoldFeatureSection(globalConfig, true),
    healthSolutionSection: createHealthSolutionSection(globalConfig, true),
    fortigoldWorksSection: createFortigoldWorksSection(globalConfig, true),
    fortigoldGutHealthSection: createFortigoldGutHealthSection(
      globalConfig,
      true
    ),
    fortigoldTestimonialsSection: createFortigoldTestimonialsSection(
      globalConfig,
      true
    ),
    fortigoldLimitedSupplySection: createFortigoldLimitedSupplySection(
      globalConfig,
      true
    ),
    pricingSection1: createPricingSection(globalConfig, true),
    fortigoldGuaranteeCertificateSection:
      createFortigoldGuaranteeCertificateSection(globalConfig, true),
    vipBonusesSection: createVipBonusesSection(globalConfig, true),
    fortigoldFAQSection: createFortigoldFAQSection(globalConfig, true),
    fortigoldLimitedSupplySection1: createFortigoldLimitedSupplySection(
      globalConfig,
      true
    ),
    pricingSection: createPricingSection(globalConfig, true),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
export {
  createScientificReferencesSection,
  createScientificRefListingSection,
  createFooterMenuSection,
  createFooterEndSection,
};
